import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 8,
    marginBottom: 12,
    boxShadow:
      '0px 1px 1px -1px rgb(0 0 0 / 16%), 0px 1px 1px 0px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 8%)'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
export default useStyles
